import { useSelector } from 'react-redux';
import { useFeatureFlag } from './useFeatureFlag';
import { FeatureFlagKeys } from '../constants/ff.posthog';
import { RemoteConfigUtils, isCredentialingV2AllowedByConfig } from '../utils/RemoteConfigUtils';

export const useCredentialingV2 = () => {
  const isCredentialingV2FF = useFeatureFlag(FeatureFlagKeys.credentialingV2);
  const clientVersion = useSelector((state) => state.users.currentUser?.client_version);
  const userState = useSelector((state) => state.users.currentUser?.address?.[0]?.state);
  const config = RemoteConfigUtils.getCredentialingV2Config();

  return (
    isCredentialingV2FF && isCredentialingV2AllowedByConfig({ clientVersion, userState, config })
  );
};
